import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, TabContent, TabPane } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import "moment/locale/id";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { api } from "../../../config";
import ModalImage from "react-modal-image";
import CurrencyInput from "react-currency-input-field";
import { QRCodeSVG } from "qrcode.react";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { getAgent, resetAgentState } from "../../../store/agent/action";
import { getBank } from "../../../store/bank/action";
import { getBankBranch } from "../../../store/bankBranch/action";
import { resetCustomerState, getCustomer as onGetCustomers, addNewCustomer as onAddNewCustomer, updateCustomer as onUpdateCustomer, deleteCustomer as onDeleteCustomer, getCustomerLoading } from "../../../store/customer/action";
import { resetPaymentMethodState, getPaymentMethod } from "../../../store/paymentMethod/action";
import { resetPaymentTermState, getPaymentTerm, addNewPaymentTerm } from "../../../store/paymentTerm/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetSalesPromoState, getSalesPromo } from "../../../store/salesPromo/action";
import { getIdentityType } from "../../../store/identityType/action";
import { resetTransactionTaxState, getTransactionTax } from "../../../store/transactionTax/action";
import { resetSalesTypeState, getSalesType } from "../../../store/salesType/action";
import { resetSalesState, getSales as onGetSales, addNewSales as onAddNewSales, updateSales as onUpdateSales, deleteSales as onDeleteSales, getSalesLoading, resetSalesCreateState } from "../../../store/sales/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { getMarital, resetMaritalState } from "../../../store/marital/action";
import { resetApplicantState, getApplicant as onGetApplicant, addNewApplicant as onAddNewApplicant, updateApplicant as onUpdateApplicant, deleteApplicant as onDeleteApplicant, getApplicantLoading } from "../../../store/applicant/action";

import logoDark from "../../../assets/images/logo-dark.png";
import logo from "../../../assets/images/logo-sm.png";
import logoHas from "../../../assets/images/LOGO HAS.png";
import logoCms from "../../../assets/images/LOGO CMS.png";
import logoWAP from "../../../assets/images/LOGO WAP.png";
import logoNSP from "../../../assets/images/LOGO NSP.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import { ButtonPrintReceipt, PrintDocReceipt } from "../Management/PrintDocReceipt";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { getTransaction, getTransactionOne } from "../../../store/actions";
import { getAccTrans } from "../../../store/accTrans/action";

const Sales = (props) => {
  const printRef = useRef(null);
  const [modal, setModal] = useState(false);
  const [modalDate, setModalDate] = useState(false);
  const [modalCustomer, setModalCustomer] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [detailType, setDetailType] = useState(null);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalJournal, setModalJournal] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [modalMediaApplicationDoc, setModalMediaApplicationDoc] = useState(false);
  const [modalApplicationDoc, setModalApplicationDoc] = useState(false);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [indexPage, setIndexPage] = useState(0);
  const [modalReceipt, setModalReceipt] = useState(false);
  const [actionType, setActionType] = useState(null);
  const dispatch = useDispatch();

  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    isApplicantCreated,
    applicantAdded,
    applicantDocuments,
    applicantDocumentLoading,
    identityTypes,
    identityTypeLoading,
    maritals,
    maritalLoading,
    agents,
    agentLoading,
    clients,
    clientLoading,
    saless,
    salesAdded,
    isSalesCreated,
    isSalesSuccess,
    loading,
    error,
    paymentMethods,
    paymentMethodLoading,
    paymentTerms,
    paymentTermLoading,
    companies,
    companyLoading,
    customers,
    customerLoading,
    isCustomerCreated,
    isCustomerSuccess,
    customerGroups,
    banks,
    bankLoading,
    bankBranches,
    bankBranchLoading,
    customerGroupsLoading,
    customerAdded,
    branches,
    branchLoading,
    transactionTaxs,
    transactionTaxLoading,
    productVarians,
    productVarianLoading,
    salesTypes,
    salesTypeLoading,
    salesPromos,
    salesPromoLoading,
    accTranss,
    loadingAccTranss,
    budgets,
    budgetLoading
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    applicantDocuments: state.ApplicantDocument.applicantDocuments,
    applicantDocumentLoading: state.ApplicantDocument.loading,
    salesAdded: state.Sales.salesAdded,
    saless: state.Sales.saless,
    loading: state.Sales.loading,
    isSalesCreated: state.Sales.isSalesCreated,
    isSalesSuccess: state.Sales.isSalesSuccess,
    agents: state.Agent.agents,
    agentLoading: state.Agent.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
    paymentTerms: state.PaymentTerm.paymentTerms,
    paymentTermLoading: state.PaymentTerm.loading,
    customers: state.Customer.customers,
    customerAdded: state.Customer.customerAdded,
    isCustomerCreated: state.Customer.isCustomerCreated,
    isCustomerSuccess: state.Customer.isCustomerSuccess,
    customerLoading: state.Customer.loading,
    customerGroups: state.CustomerGroup.customerGroups,
    customerGroupsLoading: state.CustomerGroup.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    transactionTaxs: state.TransactionTax.transactionTaxs,
    transactionTaxLoading: state.TransactionTax.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Sales.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    maritalLoading: state.Marital.loading,
    maritals: state.Marital.maritals,
    identityTypes: state.IdentityType.identityTypes,
    identityTypeLoading: state.IdentityType.loading,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    bankBranches: state.BankBranch.bankBranches,
    bankBranchLoading: state.BankBranch.loading,
    salesTypes: state.SalesType.salesTypes,
    salesTypeLoading: state.SalesType.loading,
    salesPromos: state.SalesPromo.salesPromos,
    salesPromoLoading: state.SalesPromo.loading,
    isApplicantCreated: state.Applicant.isApplicantCreated,
    applicantAdded: state.Applicant.applicantAdded,
    accTranss: state.AccTrans.accTranss,
    loadingAccTranss: state.AccTrans.loading,
    budgets: state.Budget.budgets,
    budgetLoading: state.Budget.loading,
  }));

  const [placeDefaultVal, setPlaceDefaultVal] = useState("");
  const [salesList, setSalesList] = useState([]);
  const [salesOriginalList, setSalesOriginalList] = useState([]);
  const [salesDoc, setSalesDoc] = useState([]);
  const [sales, setSales] = useState(null);
  const [info, setInfo] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [customerContactItem, setCustomerContactItem] = useState([]);
  const [customerGroupList, setCustomerGroupList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [paymentTermList, setPaymentTermList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [searchType, setSearchType] = useState("");
  const [customer, setCustomer] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const [maritalList, setMaritalList] = useState([]);
  const [salesTypeList, setSalesTypeList] = useState([]);
  const [salesPromoList, setSalesPromoList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [budgetList, setBudgetList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [bankBranchList, setBankBranchList] = useState([]);
  const [identityTypeList, setIdentityTypeList] = useState([]);

  const [applicationDoc, setApplicationDoc] = useState(null);
  const [applicationDocImg, setApplicationDocImg] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [isBudget, setIsBudget] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [isEditApllicationDoc, setIsEditApllicationDoc] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [itemName, setItemName] = useState("Print");

  const [modalMedia, setModalMedia] = useState(false);
  const [modalMediaCustomer, setModalMediaCustomer] = useState(false);
  const [salesImg, setSalesImg] = useState([]);
  const [salesImgCustomer, setSalesImgCustomer] = useState([]);

  const [receiptAmount, setReceiptAmount] = useState(0);
  const [receiptDate, setReceiptDate] = useState(0);
  const [receiptCode, setReceiptCode] = useState(0);
  const [branchCode, setBranchCode] = useState(0);
  const [receiptName, setReceiptName] = useState(0);
  const [receiptNote, setReceiptNote] = useState(0);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredSales = saless;
      if (type !== "all") {
        filteredSales = saless.filter((sales) => sales.sales_status && sales.sales_status.name === type);
      }
      setSalesList(filteredSales);
      setSalesOriginalList(filteredSales);
    }
  };

  const sourceTypeData = [
    {
      options: [
        { label: "TIKTOK", value: "TIKTOK" },
        { label: "INSTAGRAM", value: "INSTAGRAM" },
        { label: "FACEBOOK", value: "FACEBOOK" },
        { label: "YOUTUBE", value: "YOUTUBE" },
        { label: "WEBSITE", value: "WEBSITE" },
        { label: "BROSUR", value: "BROSUR" },
        { label: "MEMBER", value: "MEMBER" },
        { label: "KERABAT / TEMAN", value: "KERABAT / TEMAN" },
        { label: "LAIN-LAIN", value: "LAIN-LAIN" },
      ],
    },
  ];

  const toggleType = (type) => {
    let filteredSales = saless;
    if (type !== "all") {
      filteredSales = saless.filter((sales) => sales.typeId === type);
    }
    setSalesList(filteredSales);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (branchSelected && companySelected) {
      dispatch(getBank());
      dispatch(getBankBranch());
      dispatch(getMarital({ companyId: companySelected?.value }));
      dispatch(getIdentityType());
      handleGetAgent(companySelected?.value);
      handleGetCustomer(companySelected?.value);
      handleGetTransactionTax(companySelected?.value);
      handleGetSalesType(companySelected?.value);
      handleGetSalesPromo(companySelected?.value);
      handleGetPaymentMethod(companySelected?.value, branchSelected?.value);
      handleGetSales(companySelected?.value, branchSelected?.value, false);
      handleGetProductVariant(companySelected.value, branchSelected?.value);
      handleGetBudget(companySelected?.value, branchSelected?.value);
    }
  }, [branchSelected, companySelected]);

  const handleGetSales = (companyId, branchId, isSimple) => {
    dispatch(resetSalesState());
    dispatch(onGetSales({ companyId: companyId, branchId: branchId, cashin: true, date: "all" })); //, simple: isSimple
  };

  const handleGetPaymentTerm = (id) => {
    dispatch(resetPaymentTermState());
    dispatch(getPaymentTerm({ companyId: id, status: 2, type: "Sales" }));
  };

  const handleGetSalesType = (id) => {
    dispatch(resetSalesTypeState());
    dispatch(getSalesType({ companyId: id, status: 2 }));
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "NON CASHFLOW", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name + ", " + item?.budget_branch?.branch_code;
        const id = item.id;
        var obj = { label: name, value: id };
        if (item.type === "CASH IN")
          opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })).reverse() };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  const handleGetSalesPromo = (id) => {
    dispatch(resetSalesPromoState());
    dispatch(getSalesPromo({ companyId: id, status: 2 }));
  };

  const handleGetPaymentMethod = (id, branchId) => {
    dispatch(resetPaymentMethodState());
    dispatch(getPaymentMethod({ companyId: id, status: 2 }));
  };

  const handleGetProductVariant = (companyId, branchId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, branchId: branchId, type: 1, status: 2, available: true }));
  };

  const handleGetAgent = (companyId) => {
    dispatch(resetAgentState());
    dispatch(getAgent({ companyId: companyId, type: "book", simple: true }));
  };

  const handleGetCustomer = (companyId) => {
    dispatch(resetCustomerState());
    dispatch(onGetCustomers({ companyId: companyId }));
  };

  const handleGetTransactionTax = (companyId) => {
    dispatch(resetTransactionTaxState());
    dispatch(getTransactionTax({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(saless)) {
      let filteredSales = saless;
      if (activeTypeTab !== "all") {
        filteredSales = saless.filter((sales) => sales.sales_status && sales.sales_status.name === activeTypeTab);
      }
      setSalesList(filteredSales.map((el) => ({ ...el, isChecked: false })));
      setSalesOriginalList(filteredSales);
      setSalesOriginalList();
    }
  }, [saless]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_type",
        label: "Jenis Penjualan",
        isSelected: true,
        data: [],
      },
      {
        id: "progres",
        label: "Progres Penjualan",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_customer",
        label: "Debitur",
        isSelected: true,
        data: [],
      },
      {
        id: "phone",
        label: "No Telp Debitur",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_agent",
        label: "Marketing",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_detail",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "hoek",
        label: "Hoek",
        isSelected: true,
        data: [],
      },
      {
        id: "bill",
        label: "Tagihan",
        isSelected: true,
        data: [],
      },
      {
        id: "disc",
        label: "Diskon",
        isSelected: true,
        data: [],
      },
      // {
      //   id: "paid",
      //   label: "Terbayar",
      //   isSelected: true,
      //   data: [],
      // },
      {
        id: "paid_left",
        label: "Sisa Bayar",
        isSelected: true,
        data: [],
      },
      {
        id: "trans_no",
        label: "No Transaksi Keuangan",
        isSelected: true,
        data: [],
      },
      {
        id: "trans_at",
        label: "Tgl Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "trans_type",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "trans_amount",
        label: "Jumlah",
        isSelected: true,
        data: [],
      },

      {
        id: "trans_desc",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },

    ];

    if (salesList.length > 0) {
      salesList.forEach((sales) => {
        if (sales.isChecked) {
          let first = true;
          let doc = dataDoc.find((d) => d.id === "transaction_no");
          if (doc) doc.data.push(sales.transaction_no);

          doc = dataDoc.find((d) => d.id === "sales_type");
          if (doc) doc.data.push(sales?.sales_type?.name);

          doc = dataDoc.find((d) => d.id === "sales_customer");
          if (doc) doc.data.push(sales?.sales_customer?.name);

          doc = dataDoc.find((d) => d.id === "phone");
          if (doc) doc.data.push(sales?.sls_appl?.phone);

          doc = dataDoc.find((d) => d.id === "progres");
          if (doc) doc.data.push(sales?.sales_deal_status?.name);

          doc = dataDoc.find((d) => d.id === "sales_agent");
          if (doc) doc.data.push(sales?.sales_agent?.name);

          doc = dataDoc.find((d) => d.id === "sales_detail");
          if (doc) doc.data.push(sales.sales_detail && sales.sales_detail.length > 0 ? `${sales?.sales_detail[0]?.sales_detail_product?.product_block?.name} - ${sales?.sales_detail[0]?.sales_detail_product?.name}` : ``);

          doc = dataDoc.find((d) => d.id === "hoek");
          if (doc) doc.data.push(sales.sales_detail && sales.sales_detail.length > 0 && sales?.sales_detail[0]?.land_excess ? parseFloat(sales?.sales_detail[0]?.land_excess) : 0);

          const bill = sales.typeId === 1 ? parseFloat(sales.total_amount) - (parseFloat(0.01 * sales.sub_amount) + parseFloat(sales.sales_branch.sbum)) - parseFloat(sales.credit_amount) : parseFloat(sales.total_amount) + parseFloat(sales.book_amount) - parseFloat(sales.credit_amount);
          doc = dataDoc.find((d) => d.id === "bill");
          if (doc) doc.data.push(bill > 0 ? bill : "");

          doc = dataDoc.find((d) => d.id === "disc");
          if (doc) doc.data.push(sales?.sales_promo?.amount);

          doc = dataDoc.find((d) => d.id === "paid");
          if (doc) doc.data.push((sales.sales_trans || []).filter((el) => el.type === "CASH IN" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3)).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0));

          const disc = parseFloat(sales?.sales_promo?.amount || 0);
          const sbum = parseFloat(0.01 * sales.sub_amount) + parseFloat(sales.sales_branch.sbum);
          const total = sales.typeId === 1 ? parseFloat(sales.total_amount) - sbum + parseFloat(sales.book_amount) - parseFloat(sales.credit_amount) : parseFloat(sales.total_amount) + parseFloat(sales.book_amount) - parseFloat(sales.credit_amount);
          const amount = (sales.sales_trans || [])
            .filter((el) => el.type === "CASH IN" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
            .reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);

          doc = dataDoc.find((d) => d.id === "paid_left");
          if (doc) doc.data.push(total - amount - disc);

          (sales.sales_trans || []).filter((f) => f.statusId === 1 || f.statusId === 2 || f.statusId === 3).forEach((item) => {
            if (!first) {
              doc = dataDoc.find((d) => d.id === "transaction_no");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "sales_type");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "sales_customer");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "phone");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "progres");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "sales_agent");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "sales_detail");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "hoek");
              if (doc) doc.data.push("");
            }
            first = false;

            doc = dataDoc.find((d) => d.id === "trans_no");
            if (doc) doc.data.push(item.transaction_no);

            doc = dataDoc.find((d) => d.id === "trans_at");
            if (doc) doc.data.push(item.transactionat ? handleValidDate(item.transactionat) : "");

            doc = dataDoc.find((d) => d.id === "trans_type");
            if (doc) doc.data.push(item.type);

            doc = dataDoc.find((d) => d.id === "trans_amount");
            if (doc) doc.data.push(parseFloat(item.amount));

            doc = dataDoc.find((d) => d.id === "trans_type");
            if (doc) doc.data.push(item.type);

            doc = dataDoc.find((d) => d.id === "trans_desc");
            if (doc) doc.data.push(item.description);

          });

        }
      });
    }

    setSalesDoc(dataDoc);
  }, [salesList]);

  useEffect(() => {
    if (!isEmpty(maritals)) {
      var data = [];
      var opt = [];
      maritals.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setMaritalList(data);
    }
  }, [maritals]);

  useEffect(() => {
    if (!isEmpty(salesTypes)) {
      var data = [];
      var opt = [];
      salesTypes.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setSalesTypeList(data);
    }
  }, [salesTypes]);

  useEffect(() => {
    if (!isEmpty(salesPromos)) {
      var data = [];
      var opt = [];
      salesPromos.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setSalesPromoList(data);
    }
  }, [salesPromos]);

  useEffect(() => {
    if (!isEmpty(identityTypes)) {
      var data = [];
      var opt = [];
      identityTypes.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setIdentityTypeList(data);
    }
  }, [identityTypes]);

  useEffect(() => {
    if (!isEmpty(banks)) {
      var data = [];
      var opt = [];
      banks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankList(data);
    }
  }, [banks]);

  useEffect(() => {
    if (!isEmpty(bankBranches)) {
      var data = [];
      var opt = [];
      bankBranches.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankBranchList(data);
    }
  }, [bankBranches]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian = item.pvar_product ? item.pvar_product : "";
        const category = varian.product_category ? varian.product_category.name : "";
        const block = varian.product_block ? varian.product_block.name : "";
        const name = category + " " + block + "-" + varian.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        const priceBook = Math.round(item.pvar_product.price_book, 0);
        const land_excess = item.pvar_product ? item.pvar_product.land_excess : "";
        const land_price = item.pvar_product ? item.pvar_product.land_price : "";
        const price_handling = item.pvar_product ? item.pvar_product.price_handling : "";
        let option_name = "";
        item.pvar_options &&
          item.pvar_options.forEach((i, k) => {
            option_name += i.name + "/";
          });

        var obj = { label: name, name: name, barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId, priceBook: priceBook, land_excess: land_excess, land_price: land_price, price_handling: price_handling };
        opt.push(obj);
      });
      var option = { options: opt };
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  useEffect(() => {
    if (!isEmpty(paymentTerms)) {
      var data = [];
      var opt = [];
      paymentTerms.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentTermList(data);
    }
  }, [paymentTerms]);

  useEffect(() => {
    if (!isEmpty(transactionTaxs)) {
      var data = [];
      var opt = [];
      transactionTaxs.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const amount = parseInt(item.amount) || 0;
        var obj = { label: name, value: id, amount: amount };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTaxList(data);
    }
  }, [transactionTaxs]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const label = item?.pm_branch?.branch_code ? name + " - " + item?.pm_branch?.branch_code : name;
        const id = item.id;
        const isBooked = item.isBooked;
        var obj = { label: label, value: id, isBooked: isBooked };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentMethodList(data);
    } else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods, isEdit]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    agents.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      const status = item.agent_status && item.agent_status.name;
      var obj = { label: name, value: id, item: item };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (agents.length > 0) {
      setAgentList(data);
    }
  }, [agents]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sbum: parseFloat(item.sbum) };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(customers)) {
      var customerData = [];
      var opt = [];
      customers.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      customerData.push(option);
    }

    if (customers.length > 0) {
      setCustomerList(customerData);
    }
  }, [customers]);

  const handleDeleteSales = () => {
    if (info) {
      dispatch(onDeleteSales(info));
      setDeleteModal(false);
    }
  };

  const toggleApplicationDoc = useCallback(() => {
    if (modalApplicationDoc) {
      setModalApplicationDoc(false);
      setIsEditApllicationDoc(false);
      setIsEdit(false);
      validationApplicationDoc.resetForm();
    } else {
      setModalApplicationDoc(true);
    }
  }, [modalApplicationDoc]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSales(null);
      setIsEdit(false);
      setIsPayment(false);
      setApplicationDocImg([]);
      setApplicationDoc([]);
      setCheckDocumentList([]);
      setSelectedFiles([]);
      setOriginalFiles([]);
      setActionType(null);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDate = useCallback(() => {
    if (modalDate) {
      setModalDate(false);
      setSales(null);
      validationDate.resetForm();
    } else {
      setModalDate(true);
    }
  }, [modalDate]);

  const toggleCustomer = useCallback(() => {
    if (modalCustomer) {
      setModalCustomer(false);
      setCustomer(null);
      setCustomerContactItem([]);
      setSalesImgCustomer([]);
    } else {
      setModalCustomer(true);
    }
  }, [modalCustomer]);

  const toggleReceipt = useCallback(() => {
    if (modalReceipt) {
      setModalReceipt(false);
    } else {
      setModalReceipt(true);
    }
  }, [modalReceipt]);

  useEffect(() => {
    if (isCustomerCreated) {
      validation.setFieldValue("customer", {
        label: customerAdded.name,
        value: customerAdded.id,
      });
    }
  }, [isCustomerCreated, customerAdded]);

  useEffect(() => {
    if (isApplicantCreated) {
      setIsEdit(true);
      setApplicationDoc(applicantAdded);
      let m = applicantAdded.checked_document ? applicantAdded.checked_document.split(",") : [];
      setCheckDocumentList(m);
      validation.setFieldValue("id", applicantAdded.salesId);
      validation.setFieldValue("statusId", applicantAdded.statusId);
      validation.setFieldValue("statusDealId", applicantAdded.statusDealId);
      handleGetSales(companySelected?.value, branchSelected?.value, true);
    }
  }, [isApplicantCreated, applicantAdded]);

  useEffect(() => {
    if (isSalesCreated) {
      setSalesData(salesAdded);
      const dataInfoWithTrans = {
        ...info,
        sales_trans: salesAdded.sales_trans,
      };

      setInfo(dataInfoWithTrans);
      setIsEdit(true);
      let itemName = salesAdded.sales_detail.length > 0 ? " " + salesAdded.sales_detail[0]?.name : "";
      setItemName(itemName);
      setReceiptName(salesAdded.sales_customer.name);
      setBranchCode(salesAdded.sales_branch.branch_code);

      validation.setFieldValue("paymentMethodId", "");
      validation.setFieldValue("cash_amount", 0);
      validation.setFieldValue("statusId", salesAdded.statusId);
      validation.setFieldValue("statusDealId", salesAdded.statusDealId);
    }
  }, [isSalesCreated, salesAdded]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleMediaCustomer = useCallback(() => {
    if (modalMediaCustomer) {
      setModalMediaCustomer(false);
    } else {
      setModalMediaCustomer(true);
    }
  }, [modalMediaCustomer]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleDetail = useCallback(
    (type = null) => {
      if (modalDetail) {
        setDetailType(type);
        setModalDetail(false);
        setSales(null);
        setSelectedFiles([]);
        setOriginalFiles([]);
        setActionType(null);
      } else {
        setDetailType(type);
        setModalDetail(true);
      }
    },
    [modalDetail],
  );

  const toggleMediaApplicationDoc = useCallback(() => {
    if (modalMediaApplicationDoc) {
      setModalMediaApplicationDoc(false);
    } else {
      setModalMediaApplicationDoc(true);
    }
  }, [modalMediaApplicationDoc]);

  function handleCustomerContactAdd() {
    let fc = [];
    if (customerContactItem && customerContactItem.length) {
      customerContactItem.forEach((element) => {
        fc.push(element);
      });
    }

    fc.push({
      name: "",
      email: "",
      phone: "",
    });
    setCustomerContactItem(fc);
  }
  const handleSelectFileApplicationDoc = (file) => {
    setApplicationDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMediaApplicationDoc();
  };

  function setApplicantDocData(object, toggle) {
    setIsEditApllicationDoc(true);
    let data = object.sls_appl;
    let files = [];
    if (data) {
      if (data.applicant_file && data.applicant_file.length > 0) {
        data.applicant_file.forEach((element) => {
          files.push({
            filename: element.filename,
            originalname: element.originalname,
          });
        });
      }
      setApplicationDocImg(files);

      let m = data.checked_document ? data.checked_document.split(",") : [];
      setCheckDocumentList(m);
      setApplicationDoc({
        id: data.id,
        statusId: 1,
        companyId: object.companyId,
        clientId: object.clientId,
        salesId: object.id,
        agentId: object.agentId,
        customerId: object.customerId,
        branchId: object.branchId,
        maritalStatus: data.applicant_marital_status && {
          label: data.applicant_marital_status ? data.applicant_marital_status.name : "",
          value: data.applicant_marital_status ? data.applicant_marital_status.id : "",
        },
        applicationAt: data.applicationAt ?? "",
        birthat: data.birthat ?? "",
        birth_place: data.birth_place ?? "",
        birthat_spouse: data.birthat_spouse ?? "",
        birth_place_spouse: data.birth_place_spouse ?? "",
        name: data.name,
        email: data.email,
        phone: data.phone,
        children_number: data.children_number,
        name_spouse: data.name_spouse,
        phone_spouse: data.phone_spouse,
        job_spouse: data.job_spouse,
        city: data.city,
        address: data.address,
        address_spouse: data.address_spouse,
        identity: data.identity,
        tax_no: data.tax_no,
        bank_no: data.bank_no,
        identity_spouse: data.identity_spouse,
        knownCrApplication: data.knownCrApplication,
        emergency_contact_name: data.emergency_contact_name,
        emergency_contact_phone: data.emergency_contact_phone,
        emergency_contact_relation: data.emergency_contact_relation,
        emergency_contact_address: data.emergency_contact_address,
        emergencyKnownCrApplication: data.emergencyKnownCrApplication,
        job_informan_name: data.job_informan_name,
        job_informan_position: data.job_informan_position,
        job_business: data.job_business,
        job_business_city: data.job_business_city,
        job_business_name: data.job_business_name,
        job_business_address: data.job_business_address,
        job_informan_phone: data.job_informan_phone,
        job_business_employee: data.job_business_employee,
        job_business_date: data.job_business_date,
        job_position: data.job_position,
        job_date: data.job_date,
        job_status: data.job_status,
        job_pay_rate: data.job_pay_rate,
        job_payroll_method: data.job_payroll_method,
        job_payroll_date: data.job_payroll_date,
        job_payroll_bank: data.job_payroll_bank,
        job_retirement_age: data.job_retirement_age,
        applicant_file: files,
        motherName: data.mother_name,
      });
    }
    if (toggle) toggleApplicationDoc();
  }

  const handleClickTransDoc = (salesId, actionType = null) => {
    setActionType(actionType);
    dispatch(getAccTrans({ salesId: salesId, date: "all" }));
  };

  useEffect(() => {
    if (info && actionType !== null) {
      const dataInfoWithTrans = {
        ...info,
        sales_trans: accTranss,
      };

      setInfo(dataInfoWithTrans);
      handleSalesClick(dataInfoWithTrans, actionType);
    }
  }, [accTranss]);

  const handleSalesClick = useCallback(
    (arg, type) => {
      setSalesData(arg);
      switch (type) {
        case "detail":
          setSales((val) => ({
            ...val,
          }));
          toggleDetail(type);
          break;

        case "edit":
          setIsPayment(false);
          setIsEdit(true);
          toggle();
          break;

        case "payment":
          setIsPayment(true);
          setIsEdit(true);
          toggle();
          break;

        default:
          toggle();
          break;
      }
    },
    [toggle, userType, info],
  );

  function setSalesData(data) {
    handleGetProductVariant(data.companyId, data.branchId);
    let salesDetail = [];
    if (data.sales_detail) {
      data.sales_detail.forEach((element) => {
        salesDetail.push({
          detailId: element.id,
          itemId: element.productVarianId,
          item: {
            label: `${element.name} - ${element.barcode}`,
            value: element.productVarianId,
            name: element.name,
            sku: element.sku,
            barcode: element.barcode,
            amount: Math.round(element.amount, 0),
            brandId: element.brandId,
            productId: element.productId,
            land_excess: element.land_excess,
            land_price: element.land_price,
            price_handling: element.price_handling,
          },
          amount: Math.round(element.amount, 0),
          quantity: Math.round(element.quantity, 0),
          total: Math.round(element.amount_total, 0),
          name: element.name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: element.brandId,
          land_excess: element.land_excess,
          land_price: element.land_price,
          price_handling: element.price_handling,
          price_dp: element.price_dp,
          credit_amount: element.credit_amount,
          credit_decreased: element.credit_decreased,
          status: { label: element.statusId === 1 ? "Draft" : "Approved", value: element.statusId },
          statusId: element.statusId,
        });
      });
    }
    let files = [];
    if (data.sales_file && data.sales_file.length > 0) {
      data.sales_file.forEach((element) => {
        files.push({
          filename: element.filename,
          originalname: element.originalname,
        });
      });
    }

    handleGetBudget(data.companyId, data.branchId);

    setOriginalFiles(files);
    setSalesImg(files);
    setApplicantDocData(data);
    setSales({
      id: data.id,
      companyId: data.companyId,
      typeId: data.typeId,
      clientId: data.clientId,
      description: data.description,
      transactionat: data.transactionat,
      code: data.code === null ? "-" : data.code,
      company: data.sales_company && data.sales_company.name && { label: data.sales_company.name, value: data.sales_company.id },
      agent:
        data?.sales_agent === null
          ? ""
          : {
            label: data?.sales_agent?.name,
            value: data?.sales_agent?.id,
          },
      branch:
        data?.sales_branch == null
          ? ""
          : {
            label: data?.sales_branch?.name,
            value: data?.sales_branch?.id,
            sbum: parseFloat(data?.sales_branch?.sbum),
          },
      client:
        data?.sales_client === null
          ? ""
          : {
            label: data?.sales_client?.name,
            value: data?.sales_client?.id,
          },
      sales_type:
        data?.sales_type === null
          ? ""
          : {
            label: data?.sales_type?.name,
            value: data?.sales_type?.id,
          },
      sls_bb:
        data?.sls_bb === null
          ? ""
          : {
            label: data?.sls_bb?.name,
            value: data?.sls_bb?.id,
          },
      customer:
        data?.sales_customer === null
          ? ""
          : {
            label: data?.sales_customer?.name,
            value: data?.sales_customer?.id,
          },
      sales_trans: data?.sales_trans,
      sales_channel: data.sales_channel && { label: data.sales_channel.name, value: data.sales_channel.id },
      status: data.sales_status && { label: data.sales_status.name, value: data.sales_status.id },
      status_deal: data.sales_deal_status && { label: data.sales_deal_status.name, value: data.sales_deal_status.id },
      status_bank: data.sales_bank_status && { label: data.sales_bank_status.name, value: data.sales_bank_status.id },
      taxAmount: data.tax_amount === null ? 0 : data.tax_amount,
      totalAmount: data.total_amount === null ? 0 : data.total_amount,
      disc_amount: data.disc_amount === null ? 0 : parseFloat(data.disc_amount),
      tax_amount: data.tax_amount === null ? 0 : parseFloat(data.tax_amount),
      total_amount: data.total_amount === null ? 0 : parseFloat(data.total_amount),
      sub_amount: data.sub_amount === null ? 0 : parseFloat(data.sub_amount),
      book_amount: data.book_amount === null ? 0 : parseFloat(data.book_amount),
      handling_amount: data.handling_amount === null ? 0 : parseFloat(data.handling_amount),
      shipment_amount: data.shipment_amount === null ? 0 : parseFloat(data.shipment_amount),
      credit_amount: data.credit_amount === null ? 0 : parseFloat(data.credit_amount),
      statusId: data.statusId,
      statusDealId: data.statusDealId,
      tenor: data.tenor,
      bankat: data.bankat,
      completedat: data.completedat,
      approvedat: data.approvedat,
      description_bank: data.description_bank,
      sales_detail: data.sales_detail,
      item: salesDetail,
    });
  }

  const checkedAll = () => {
    const allChecked = salesList.every((item) => item.isChecked && item.typeId !== 4);
    const updatedData = salesList.map((item) => ({
      ...item,
      isChecked: !allChecked,
    }));

    setSalesList(updatedData);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={salesList.every((item) => item.isChecked)} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          const data = cellProps.row.original;
          return (
            <div className="hstack gap-2 pe-0 me-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = salesList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setSalesList(updatedData);
                }}
              />
              <button
                type="button"
                className={userType === "admin" || userType === "client" ? "btn btn-soft-info btn-sm btn-label waves-effect waves-light rounded-pill pe-3" : userRole && userRole.split(",").indexOf("updateSales") !== -1 ? "btn btn-soft-success btn-sm btn-label waves-effect waves-light rounded-pill pe-3" : "btn-sm d-none"}
                onClick={() => {
                  let itemName = data.sales_detail.length > 0 ? " " + data.sales_detail[0]?.name : "";
                  setItemName(itemName);
                  setReceiptName(data.sales_customer.name);
                  setBranchCode(data.sales_branch.branch_code);
                  setInfo(data);
                  setIsPayment(true);
                  setIsEdit(true);
                  // handleSalesClick(data, "payment");
                  handleClickTransDoc(data.id, "payment");
                }}
              >
                <i className="ri-add-line label-icon align-middle rounded-pill fs-16 me-0"></i> BAYAR
                {loadingAccTranss && info.id === data.id && actionType === "payment" && (
                  <Spinner size="sm" className="ms-2 flex-shrink-0" role="status">
                    Loading...
                  </Spinner>
                )}
              </button>
              <button
                type="button"
                className={userType === "admin" || userType === "client" ? "btn btn-soft-warning btn-sm waves-effect waves-light rounded-pill" : userRole && userRole.split(",").indexOf("updateSales") !== -1 ? "btn btn-soft-warning btn-sm waves-effect waves-light rounded-pill" : "btn-sm d-none"}
                id="create-btn"
                onClick={() => {
                  setInfo(data);
                  setIsPayment(false);
                  setIsEdit(true);
                  // handleSalesClick(data, "edit");
                  handleClickTransDoc(data.id, "edit");
                }}
              >
                <i className="ri-pencil-line align-bottom fs-14"></i>
                {loadingAccTranss && info.id === data.id && actionType === "edit" && (
                  <Spinner size="sm" className="ms-2 flex-shrink-0" role="status">
                    Loading...
                  </Spinner>
                )}
              </button>
            </div>
          );
        },
      },
      {
        Header: "No Transaksi",
        accessor: "transaction_no",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let stat;
          let statDeal;
          let statName = data.sales_status && data.sales_status.name;
          let statDealId = data.sales_deal_status && data.sales_deal_status.id;
          switch (statName) {
            case "DRAFT":
              stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
              break;
            case "PENDING":
              stat = <span className="badge text-uppercase badge-soft-secondary">{statName}</span>;
              break;
            case "CONFIRMED":
              stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
              break;
            case "PROCESSED":
              stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
              break;
            case "SHIPPED":
              stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
              break;
            case "COMPLETED":
              stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
              break;
            default:
              stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
              break;
          }

          switch (statDealId) {
            case 3:
              statDeal =
                data.typeId === 3 || data.typeId === 4 ? (
                  <span className="badge text-uppercase" style={{ background: "#CFECF7", color: "#687FE5" }}>
                    {"CASH"}
                  </span>
                ) : (
                  <span className="badge text-uppercase" style={{ background: "#ffe7ff", color: "#ea33f7" }}>
                    {data.sales_deal_status.name}
                  </span>
                );
              break;
            case 4:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#ede3c5", color: "#806b29" }}>
                  {data.sales_deal_status.name}
                </span>
              );
              break;
            case 5:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#EAFAEA", color: "#65B741" }}>
                  {data.sales_deal_status.name}
                </span>
              );
              break;
            case 6:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#FFFDF0", color: "#ffCC55" }}>
                  {data.sales_deal_status.name}
                </span>
              );
              break;
            case 7:
              statDeal = <span className="badge text-uppercase badge-soft-info">{data.sales_deal_status.name}</span>;
              break;
            case 8:
              statDeal = (
                <span className="badge text-uppercase" style={{ background: "#E8F9FF", color: "#2cc2c4" }}>
                  {data.sales_deal_status.name}
                </span>
              );
              break;
            default:
              statDeal = "";
              break;
          }
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                setItemName(itemName);
                setReceiptName(data.sales_customer.name);
                setBranchCode(data.sales_branch.branch_code);
                setInfo(data);
                setIsPayment(true);
                setIsEdit(true);

                handleClickTransDoc(data.id, "payment");
                // handleSalesClick(data, "payment");
              }}
            >
              <div className="mb-1">
                <span className="fw-semibold">
                  {data.transaction_no}{" "}
                  {loadingAccTranss && info.id === data.id && actionType === "payment" && (
                    <Spinner size="sm" className="flex-shrink-0" role="status">
                      Loading...
                    </Spinner>
                  )}
                </span>
              </div>
              <div className="hstack gap-2">
                {stat}
                {statDeal}
              </div>
            </div>
          );
        },
      },
      {
        id: "Tanggal",
        Header: "Tanggal",
        accessor: "bookat",
        filterable: false,
        Cell: (data) => {
          return data.row.original.transactionat ? handleValidDate(data.row.original.transactionat, "D/MM/YYYY") : "";
        },
      },
      {
        Header: "Konsumen",
        accessor: "sales_customer.name",
        filterable: true,
      },
      {
        id: "Marketing",
        Header: "Marketing",
        accessor: "sales_agent.name",
        filterable: true,
      },
      // {
      //   Header: "Terbayar",
      //   accessor: (data) => (data.sales_trans || [])
      //     .filter((el) => el.type === "CASH IN" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
      //     .reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
      //   filterable: true,
      //   Cell: (data) => {
      //     return <div className={data.value > 1 ? "fw-semibold text-success" : "fw-semibold text-danger"}>{currencyFormat(data.value)}</div>;
      //   },
      // },
      {
        Header: "Tagihan",
        accessor: (data) => data.typeId === 1 ? parseFloat(data.total_amount) - (parseFloat(0.01 * data.sub_amount) + parseFloat(data.sales_branch.sbum)) - parseFloat(data.credit_amount) : parseFloat(data.total_amount) + parseFloat(data.book_amount) - parseFloat(data.credit_amount),
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          return <div className="fw-semibold">{data.sales_detail.length && currencyFormat(cell.value)}</div>;
        },
      },
      {
        Header: "Diskon",
        accessor: "sales_promo.amount",
        filterable: true,
        Cell: (cell) => {
          return <div className="fw-semibold">{currencyFormat(cell.value)}</div>;
        },
      },
      // {
      //   Header: "Sisa Bayar",
      //   accessor: (data) => {
      //     const disc = parseFloat(data?.sales_promo?.amount || 0);
      //     const sbum = parseFloat(0.01 * data.sub_amount) + parseFloat(data.sales_branch.sbum);
      //     const total = data.typeId === 1 ? parseFloat(data.total_amount) - sbum + parseFloat(data.book_amount) - parseFloat(data.credit_amount) : parseFloat(data.total_amount) + parseFloat(data.book_amount) - parseFloat(data.credit_amount);
      //     let amount = (data.sales_trans || [])
      //       .filter((el) => el.type === "CASH IN" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
      //       .reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      //     return total - amount - disc;
      //   },
      //   filterable: true,
      //   Cell: (cell) => {
      //     const data = cell.row.original;
      //     return <div className={cell.value > 1 ? "fw-semibold text-danger" : "fw-semibold  text-success"}>{data.sales_detail.length && currencyFormat(cell.value)}</div>;
      //   },
      // },
      {
        id: "Promo",
        Header: "Promo",
        accessor: "sales_promo.name",
        filterable: true,
      },
      {
        id: "Proyek",
        Header: "Project",
        accessor: "sales_branch.name",
        filterable: true,
      },
    ],
    [salesList, handleSalesClick, userRole, userType, accTranss, loadingAccTranss, actionType],
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: salesList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Proyek", "Booking"],
        pageIndex: indexPage,
        pageSize: 25,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      type: searchType.value ?? "",
      startat: startat,
      endat: endat,
      branchId: branchSelected.value ?? "",
      cashin: true
    };
    dispatch(onGetSales(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setSearchType("");
    setSearchValue("");
    handleGetSales(branchSelected?.companyId, branchSelected?.value, true);
  }

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteSales(element.value));
    });
    checkall.checked = false;
  };

  const handleDeleteFileCustomer = (file) => {
    if (isEdit) {
      const newState = salesImgCustomer.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, originalname: file.originalname, mimetype: file.mimetype, isDeleted: true };
        }
        return obj;
      });
      setSalesImgCustomer(newState);
    } else {
      const index = salesImgCustomer.findIndex((fl) => fl.filename === file.filename);
      setSalesImgCustomer((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setSalesImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const handleSelectFileCustomer = (file) => {
    setSalesImgCustomer((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMediaCustomer();
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (sales) {
        sales.setApprove = true;
        sales.approval_note = values.approval_note;
        dispatch(onUpdateSales(sales));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (sales && sales.id) || 0,
      statusId: (sales && sales.statusId) || 1,
      statusDealId: (sales && sales.statusDealId) || 3,
      sls_bb: (sales && sales.sls_bb) ?? "",
      sales_type: (sales && sales.sales_type) ?? "",
      sales_promo: (sales && sales.sales_promo) ?? "",
      company: (sales && sales.company) || companySelected,
      client: (sales && sales.client) || clientSelected,
      branch: (sales && sales.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
      shipmentCarrier: (sales && sales.shipmentCarrier) || 0,
      shipmentMethod: (sales && sales.shipmentMethod) || 0,
      paymentMethod: (sales && sales.paymentMethod) ?? "",
      //paymentTerm: (sales && sales.paymentTerm) || 0,
      code: (sales && sales.code) ?? "",
      transactionat: (sales && sales.transactionat) ?? "",
      agent: (sales && sales.agent) ?? "",
      description: (sales && sales.description) ?? "",
      customer: (sales && sales.customer) ?? "",
      status: (sales && sales.status) ?? "",
      status_deal: (sales && sales.status_deal) ?? "",
      status_bank: (sales && sales.status_bank) ?? "",
      sales_channel: (sales && sales.sales_channel) ?? "",
      tax: (sales && sales.tax) || 0,
      tax_amount: (sales && sales.tax_amount) || 0,
      shipmentAmount: (sales && sales.shipmentAmount) || 0,
      disc_amount: (sales && sales.disc_amount) || 0,
      total_amount: (sales && sales.total_amount) || 0,
      sub_amount: (sales && sales.sub_amount) || 0,
      book_amount: (sales && sales.book_amount) || 0,
      handling_amount: (sales && sales.handling_amount) || 0,
      shipment_amount: (sales && sales.shipment_amount) || 0,
      credit_amount: (sales && sales.credit_amount) || 0,
      tenor: (sales && sales.tenor) || 0,
      cash_amount: sales && sales.cash_amount ? sales.cash_amount : 0,
      cashat: (sales && sales.cashat) ?? "",
      bankat: (sales && sales.bankat) ?? "",
      completedat: (sales && sales.completedat) ?? "",
      description_bank: (sales && sales.description_bank) ?? "",
      item: (sales && sales.item) || [],
      budget: (sales && sales.budget) ?? "",
    },
    validationSchema: Yup.object({
      branch: Yup.object().required("Silahkan pilih proyek").nullable(true),
      company: Yup.object().required("Silahkan pilih perusahaan").nullable(true),
      client: Yup.object().required("Silahkan pilih grup perusahaan").nullable(true),
      //agent: Yup.object().required("Silahkan pilih marketing").nullable(true),
      customer: Yup.object().required("Silahkan pilih konsumen").nullable(true),
      sales_type: Yup.object().required("Silahkan pilih jenis penjualan").nullable(true),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        let editSubmit = {
          id: values.id,
          budgetId: values.budget.value,
          statusId: values.statusId,
          statusDealId: values.statusDealId,
          statusBankId: values.status_bank.value,
          tenor: values.tenor,
          bankat: values.bankat,
          completedat: values.completedat,
          description_bank: values.description_bank,
          agentId: values.agent.value,
          branchId: values.branch.value,
          shipmentCarrierId: values.shipmentCarrier.value,
          shipmentMethodId: values.shipmentMethod.value,
          shipment_amount: values.shipmentAmount,
          paymentMethodId: values.paymentMethod.value,
          //paymentTermId: values.paymentTerm.value,
          taxId: values.tax.value,
          transactionat: values.transactionat,
          typeId: values.sales_type.value,
          promoId: values.sales_promo.value,
          bankBranchId: values.sls_bb.value,
          description: values.description,
          clientId: values.client.value,
          customerId: values.customer.value,
          companyId: values.company.value,
          channelId: values.sales_channel.value,
          tax_amount: values.tax_amount,
          shipment_amount_amount: values.shipment_amount,
          disc_amount: values.disc_amount,
          sub_amount: values.sub_amount,
          book_amount: values.cash_amount,
          handling_amount: values.handling_amount,
          total_amount: values.total_amount,
          credit_amount: values.credit_amount,
          cashat: values.cashat,
          cash_amount: values.cash_amount,
          sales_detail: JSON.stringify(validation.values.item),
          files: salesImg.length > 0 ? salesImg : [],
        };
        if (isPayment) editSubmit.addSalesPayment = true;
        dispatch(onUpdateSales(editSubmit));
      } else {
        let addSubmit = {
          budgetId: values.budget.value,
          statusId: 1,
          statusDealId: 3,
          statusBankId: values.status_bank.value,
          tenor: values.tenor,
          bankat: values.bankat,
          completedat: values.completedat,
          description_bank: values.description_bank,
          agentId: values.agent.value,
          branchId: values.branch.value,
          shipmentCarrierId: values.shipmentCarrier.value,
          shipmentMethodId: values.shipmentMethod.value,
          shipment_amount: values.shipmentAmount,
          paymentMethodId: values.paymentMethod.value,
          //paymentTermId: values.paymentTerm.value,
          taxId: values.tax.value,
          transactionat: values.transactionat,
          typeId: values.sales_type.value,
          promoId: values.sales_promo.value,
          bankBranchId: values.sls_bb.value,
          description: values.description,
          clientId: values.client.value,
          customerId: values.customer.value,
          companyId: values.company.value,
          channelId: values.sales_channel.value,
          tax_amount: values.tax_amount,
          shipment_amount_amount: values.shipment_amount,
          disc_amount: values.disc_amount,
          sub_amount: values.sub_amount,
          book_amount: values.cash_amount,
          handling_amount: values.handling_amount,
          total_amount: values.total_amount,
          credit_amount: values.credit_amount,
          cashat: values.cashat,
          cash_amount: values.cash_amount,
          sales_detail: JSON.stringify(validation.values.item),
          files: salesImg.length > 0 ? salesImg : [],
        };
        dispatch(onAddNewSales(addSubmit));
      }
      // validation.resetForm();
      // toggle();
    },
  });

  const validationDate = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (info && info.id) || 0,
      transactionat: (info && info.transactionat) ?? "",
      docat: (info && info.docat) ?? "",
      sales_promo:
        info && info.sales_promo
          ? {
            label: info.sales_promo.name,
            value: info.sales_promo.id,
          }
          : "",
      sp3at: (info && info.sp3at) ?? "",
      bankat: (info && info.bankat) ?? "",
      completedat: (info && info.completedat) ?? "",
    },
    validationSchema: Yup.object({
      transactionat: Yup.string().required("Silahkan Input Tanggal Transaksi").nullable(true),
    }),
    onSubmit: (values) => {
      let editSubmit = {
        id: values.id,
        promoId: values.sales_promo.value,
        isDateUpdate: true,
        transactionat: values.transactionat,
        docat: values.docat,
        sp3at: values.sp3at,
        bankat: values.bankat,
        completedat: values.completedat,
      };
      dispatch(onUpdateSales(editSubmit));
      validationDate.resetForm();
      toggleDate();
    },
  });

  const validationCustomer = useFormik({
    enableReinitialize: true,
    initialValues: {
      company: (customer && customer.company) || companySelected,
      client: (customer && customer.client) || clientSelected,
      customerGroup: (customer && customer.customerGroup) ?? "",
      name: (customer && customer.name) ?? "",
      agent: (customer && customer.agent) ?? "",
      email: (customer && customer.email) ?? "",
      password: (customer && customer.password) ?? "",
      phone: (customer && customer.phone) ?? "",
      birthat: (customer && customer.birthat) ?? "",
      insurance_number: (customer && customer.insurance_number) ?? "",
      tax_number: (customer && customer.tax_number) ?? "",
      number: (customer && customer.number) ?? "",
      website: (customer && customer.website) ?? "",
      description: (customer && customer.description) ?? "",
      address: (customer && customer.address) ?? "",
      customer_status: customer && customer.customer_status,
      village: customer && customer.village,
      identity: (customer && customer.identity) ?? "",
      identity_type: (customer && customer.identityType) ?? "",
      bank: (customer && customer.bank) ?? "",
      idBank: (customer && customer.idBank) || 0,
      zip: (customer && customer.zip) ?? "",
      street: (customer && customer.street) ?? "",
      image: (customer && customer.image) ?? "",

      source_type: (customer && customer.source_type) ?? "",
      visitedat: (customer && customer.visitedat) ?? "",
      description_result: (customer && customer.description_result) ?? "",
      description_visit: (customer && customer.description_visit) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Nama").nullable(true),
      phone: Yup.string().required("Silahkan Input Phone Number").nullable(true),
      visitedat: Yup.string().required("Please Input Tanggal Kunjungan").nullable(true),
      // client: Yup.object().required("Silahkan Input grup perusahaan").nullable(true),
      // company: Yup.object().required("Silahkan pilih Company").nullable(true),
      // agent: Yup.object().required("Silahkan pilih Agent").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getCustomerLoading());
      if (isEdit) {
        let editDataSubmit = {
          id: customer.id,
          groupId: values.customerGroup.value,
          clientId: values.client.value,
          companyId: values.company.value,
          agentId: values.agent.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          insurance_number: values.insurance_number,
          tax_number: values.tax_number,
          website: values.website,
          identityId: values.identity_type.value,
          identity: values.identity,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          source_type: values.source_type?.value ?? "",
          visitedat: values.visitedat,
          description: values.description,
          description_result: values.description_result,
          description_visit: values.description_visit,
          zip: values.zip,
          village: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[0].value : customer.village,
          district: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 4].value : customer.district,
          city: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 3].value : customer.city,
          province: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 2].value : customer.province,
          country: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 1].value : customer.country,
          street: values.street,
          customer_contact: JSON.stringify(customerContactItem),
          image: values.image,
          files: salesImgCustomer.length > 0 ? salesImgCustomer : [],
        };
        dispatch(onUpdateCustomer(editDataSubmit));
      } else {
        var addDataSubmit = {
          clientId: values.client.value,
          companyId: values.company.value,
          groupId: values.customerGroup.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          insurance_number: values.insurance_number,
          tax_number: values.tax_number,
          website: values.website,
          identityId: values.identity_type.value,
          identity: values.identity,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          agentId: values.agent.value,
          source_type: values.source_type?.value ?? "",
          visitedat: values.visitedat,
          description: values.description,
          description_result: values.description_result,
          description_visit: values.description_visit,
          zip: values.zip,
          village: values.address.value && values.address.value.terms[0].value,
          district: values.address.value && values.address.value.terms[values.address.value.terms.length - 4].value,
          city: values.address.value && values.address.value.terms[values.address.value.terms.length - 3].value,
          province: values.address.value && values.address.value.terms[values.address.value.terms.length - 2].value,
          country: values.address.value && values.address.value.terms[values.address.value.terms.length - 1].value,
          street: values.street,
          customer_contact: JSON.stringify(customerContactItem),
          image: values.image,
          files: salesImgCustomer.length > 0 ? salesImgCustomer : [],
        };
        dispatch(onAddNewCustomer(addDataSubmit));
      }
      validationCustomer.resetForm();
      toggleCustomer();
    },
  });

  const validationApplicationDoc = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (applicationDoc && applicationDoc.id) ?? "",
      maritalStatus: (applicationDoc && applicationDoc.maritalStatus) ?? "",
      name: (applicationDoc && applicationDoc.name) ?? "",
      city: (applicationDoc && applicationDoc.city) ?? "",
      address: (applicationDoc && applicationDoc.address) ?? "",
      address_spouse: (applicationDoc && applicationDoc.address_spouse) ?? "",
      identity: (applicationDoc && applicationDoc.identity) ?? "",
      birthat: (applicationDoc && applicationDoc.birthat) ?? "",
      birth_place: (applicationDoc && applicationDoc.birth_place) ?? "",
      birthat_spouse: (applicationDoc && applicationDoc.birthat_spouse) ?? "",
      birth_place_spouse: (applicationDoc && applicationDoc.birth_place_spouse) ?? "",
      tax_no: (applicationDoc && applicationDoc.tax_no) ?? "",
      bank_no: (applicationDoc && applicationDoc.bank_no) ?? "",
      identity_spouse: (applicationDoc && applicationDoc.identity_spouse) ?? "",
      email: (applicationDoc && applicationDoc.email) ?? "",
      phone: (applicationDoc && applicationDoc.phone) ?? "",
      children_number: (applicationDoc && applicationDoc.children_number) ?? "",
      name_spouse: (applicationDoc && applicationDoc.name_spouse) ?? "",
      phone_spouse: (applicationDoc && applicationDoc.phone_spouse) ?? "",
      job_spouse: (applicationDoc && applicationDoc.job_spouse) ?? "",
      knownCrApplication: (applicationDoc && applicationDoc.knownCrApplication) || false,
      emergency_contact_name: (applicationDoc && applicationDoc.emergency_contact_name) ?? "",
      emergency_contact_address: (applicationDoc && applicationDoc.emergency_contact_address) ?? "",
      emergency_contact_phone: (applicationDoc && applicationDoc.emergency_contact_phone) ?? "",
      emergency_contact_relation: (applicationDoc && applicationDoc.emergency_contact_relation) ?? "",
      emergencyKnownCrApplication: (applicationDoc && applicationDoc.emergencyKnownCrApplication) || false,
      job_informan_name: (applicationDoc && applicationDoc.job_informan_name) ?? "",
      job_informan_position: (applicationDoc && applicationDoc.job_informan_position) ?? "",
      job_business: (applicationDoc && applicationDoc.job_business) ?? "",
      job_business_name: (applicationDoc && applicationDoc.job_business_name) ?? "",
      job_business_city: (applicationDoc && applicationDoc.job_business_city) ?? "",
      job_business_address: (applicationDoc && applicationDoc.job_business_address) ?? "",
      job_informan_phone: (applicationDoc && applicationDoc.job_informan_phone) ?? "",
      job_business_employee: (applicationDoc && applicationDoc.job_business_employee) ?? "",
      job_business_date: (applicationDoc && applicationDoc.job_business_date) ?? "",
      job_position: (applicationDoc && applicationDoc.job_position) ?? "",
      job_date: (applicationDoc && applicationDoc.job_date) ?? "",
      job_status: (applicationDoc && applicationDoc.job_status) ?? "",
      job_pay_rate: (applicationDoc && applicationDoc.job_pay_rate) ?? "",
      job_payroll_method: (applicationDoc && applicationDoc.job_payroll_method) ?? "",
      job_payroll_date: (applicationDoc && applicationDoc.job_payroll_date) ?? "",
      job_payroll_bank: (applicationDoc && applicationDoc.job_payroll_bank) ?? "",
      job_retirement_age: (applicationDoc && applicationDoc.job_retirement_age) ?? "",
      client: (applicationDoc && applicationDoc.client) || clientSelected,
      company: (applicationDoc && applicationDoc.company) || companySelected,
      customer: (applicationDoc && applicationDoc.customer) ?? "",
      applicationAt: (applicationDoc && applicationDoc.applicationAt) ?? "",
      salesId: applicationDoc && applicationDoc.salesId,
      motherName: (applicationDoc && applicationDoc.motherName) ?? "",
    },
    onSubmit: (values) => {
      let ele = document.querySelectorAll(".checked-method-all");
      let arrData = "";
      ele.forEach((ele) => {
        if (ele.checked === true) {
          arrData += ele.value + ",";
        }
      });
      let data = {
        salesId: applicationDoc && applicationDoc.salesId ? applicationDoc.salesId : null,
        maritalStatusId: values.maritalStatus.value,
        city: values.city,
        address: values.address,
        address_spouse: values.address_spouse,
        identity: values.identity,
        tax_no: values.tax_no,
        bank_no: values.bank_no,
        identity_spouse: values.identity_spouse,
        name: values.name,
        email: values.email,
        phone: values.phone,
        children_number: values.children_number,
        name_spouse: values.name_spouse,
        phone_spouse: values.phone_spouse,
        job_spouse: values.job_spouse,
        birthat: values.birthat,
        birth_place: values.birth_place,
        birthat_spouse: values.birthat_spouse,
        birth_place_spouse: values.birth_place_spouse,
        knownCrApplication: values.knownCrApplication,
        emergency_contact_name: values.emergency_contact_name,
        emergency_contact_phone: values.emergency_contact_phone,
        emergency_contact_relation: values.emergency_contact_relation,
        emergency_contact_address: values.emergency_contact_address,
        emergencyKnownCrApplication: values.emergencyKnownCrApplication,
        job_informan_name: values.job_informan_name,
        job_informan_position: values.job_informan_position,
        job_business: values.job_business,
        job_business_city: values.job_business_city,
        job_business_name: values.job_business_name,
        job_business_address: values.job_business_address,
        job_informan_phone: values.job_informan_phone,
        job_business_employee: values.job_business_employee,
        job_business_date: values.job_business_date,
        job_position: values.job_position,
        job_date: values.job_date,
        job_status: values.job_status,
        job_pay_rate: values.job_pay_rate,
        job_payroll_method: values.job_payroll_method,
        job_payroll_date: values.job_payroll_date,
        job_payroll_bank: values.job_payroll_bank,
        job_retirement_age: values.job_retirement_age,
        applicationAt: values.applicationAt,
        files: applicationDocImg.length > 0 ? applicationDocImg : [],
        clientId: validation.values.client.value ? validation.values.client.value : applicationDoc.clientId,
        companyId: validation.values.company.value ? validation.values.company.value : applicationDoc.companyId,
        customerId: validation.values.customer.value ? validation.values.customer.value : applicationDoc.customerId,
        branchId: validation.values.branch.value ? validation.values.branch.value : applicationDoc.branchId,
        agentId: validation.values.agent.value ? validation.values.agent.value : applicationDoc.agentId,
        checked_document: arrData.slice(0, -1),
        mother_name: values.motherName,
      };

      if (isEditApllicationDoc) {
        data.id = applicationDoc.id;
        dispatch(onUpdateApplicant(data));
      } else {
        dispatch(onAddNewApplicant(data));
      }
      toggleApplicationDoc();
    },
  });

  document.title = "Kasir | PESONA KAHURIPAN";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={salesList} />
      <DeleteModal show={deleteModal} title={info ? info.actionTitle : null} onDeleteClick={handleDeleteSales} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Penjualan" pageTitle="Penjualan" loading={loading || loadingAccTranss}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createSales") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
              id="create-btn"
              onClick={() => {
                setSales(null);
                setInfo(null);
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-add-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={salesDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                          setSalesList(saless);
                          setSalesOriginalList(saless);
                          setSearchType("");
                          setFilterDate(null);
                        }}
                        href="#"
                      >
                        <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> SEMUA PENJUALAN
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT </NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "CONFIRMED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> CONFIRMED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "PROCESSED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> PROCESSED
                      </NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "5" }, "fw-semibold")} onClick={() => {
                          toggleTab("5", "SHIPPED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> SHIPPED</NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "6" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("6", "COMPLETED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> COMPLETED
                      </NavLink>
                    </NavItem> */}
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "7" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("7", "CANCELED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> CANCELED
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "8" }, "fw-semibold")} onClick={() => {
                          toggleTab("8", "RETURNED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RETURNED</NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "9" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("9", "REFUNDED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> REFUNDED
                      </NavLink>
                    </NavItem> */}
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Search...`}
                              value={searchValue ?? ""}
                            />
                          </div>
                        </Col>
                        <Col sm={3}>
                          <Select
                            name="searchType"
                            value={searchType}
                            placeholder="Filter Jenis Penjualan"
                            onChange={(e) => {
                              setSearchType(e);
                              toggleType(e.value);
                            }}
                            options={salesTypeList}
                          ></Select>
                        </Col>
                        <Col sm={3}>
                          <div className="me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              value={filterDate}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                          </div>
                        </Col>
                        <Col sm={1}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1" style={{ minHeight: "320px" }}>
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} value={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModalDate" isOpen={modalDate} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDate}>
                    {!!isEdit ? "Form Penjualan" : "Form Penjualan"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDate.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody className={info && info.statusId > 1 && parseFloat(info.book_amount) > 1 ? "border-bottom ps-4 pe-4 position-relative" : "ps-4 pe-4 position-relative d-none"}>
                        <Row>
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-1 fs-16 fw-semibold">{info && info.sales_company && info.sales_company.name}</div>
                              <div className="mb-1 fs-14">{info && info.sales_branch && info.sales_branch.name}</div>
                              <div className="mb-3 fs-14">{info && info.sales_type && info.sales_type.name}</div>
                            </div>
                          </Col>
                          <Col lg={3}></Col>
                          <Col lg={4} className="ms-auto">
                            <div className="mb-2 fs-14 fw-semibold">No Penjualan : {info && info.code && info.code}</div>
                            <div className="mb-2 fs-14 fw-semibold">Bank Pengajuan : {info && info.sls_bb && info.sls_bb.name}</div>
                            <div className="mb-2 fs-14 fw-semibold">
                              {info && info.sales_customer && info.sales_customer.name} <span className="badge text-uppercase badge-soft-info fs-12">{info && info.sales_agent && info.sales_agent.name}</span>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="pt-0 pb-4 ps-4 pe-4">
                        <div className="pt-4 row">
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal Booking</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("transactionat", dateStr);
                              }}
                              value={validationDate.values.transactionat ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal Kantor</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("docat", dateStr);
                              }}
                              value={validationDate.values.docat ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal Pengajuan</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("bankat", dateStr);
                              }}
                              value={validationDate.values.bankat ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal SP3K</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("sp3at", dateStr);
                              }}
                              value={validationDate.values.sp3at ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Tanggal Akad</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationDate.setFieldValue("completedat", dateStr);
                              }}
                              value={validationDate.values.completedat ?? ""}
                            />
                          </div>
                          <div className="mb-3 col-lg-6">
                            <label>Promo Penjualan</label>
                            <Select
                              name="sales_promo"
                              placeholder="Pilih Diskon Penjualan"
                              value={validationDate.values.sales_promo}
                              onChange={(e) => {
                                validationDate.setFieldValue("sales_promo", e);
                              }}
                              options={salesPromoList}
                            ></Select>
                          </div>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={toggleDate}>
                          TUTUP
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            PERBARUI DATA PENJUALAN{" "}
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Penjualan" : "Form Penjualan"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody className={!!isEdit && !!isPayment ? "border-bottom ps-4 pe-4 position-relative" : !!isEdit && !isPayment ? "d-none" : "d-none"}>
                        <Row>
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-1 fs-16 fw-semibold">{validation.values.company && validation.values.company.label}</div>
                              <div className="mb-1 fs-14">{validation.values.branch && validation.values.branch.label}</div>
                              <div className="mb-3 fs-14">{validation.values.sales_type && validation.values.sales_type.label}</div>
                            </div>
                          </Col>
                          <Col lg={3}></Col>
                          <Col lg={4} className="ms-auto">
                            <div className="mb-2 fs-14 fw-semibold">No Penjualan : {validation.values.code && validation.values.code}</div>
                            <div className="mb-2 fs-14 fw-semibold">
                              {validation.values.customer && validation.values.customer.label} <span className="badge text-uppercase badge-soft-info fs-12">{validation.values.agent && validation.values.agent.label}</span>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className={!!isEdit && !isPayment ? "pt-3 ps-4 pe-4 position-relative" : !!isEdit && !!isPayment ? "d-none" : "pt-3 ps-4 pe-4 position-relative"}>
                        <Row className="border-bottom pb-3">
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-3">
                                <div className="position-relative">
                                  <Select
                                    name="client"
                                    value={validation.values.client}
                                    isDisabled={userType === "admin" || userType === "client" ? false : true}
                                    placeholder="Pilih Grup Usaha"
                                    onChange={(e) => {
                                      dispatch(setClientSelect(e));
                                      validation.setFieldValue("client", e);
                                    }}
                                    options={clientList}
                                  ></Select>
                                  <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                    {" "}
                                    {clientLoading && (
                                      <Spinner color="primary" size="sm">
                                        Loading...
                                      </Spinner>
                                    )}
                                  </div>
                                </div>
                                {validation.touched.client && validation.errors.client && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.client}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <div className="position-relative">
                                  <Select
                                    name="company"
                                    value={validation.values.company}
                                    placeholder="Pilih Perusahaan"
                                    //isDisabled={userType === "admin" || userType === "client" ? false : true}
                                    onChange={(e) => {
                                      dispatch(setCompanySelect(e));
                                      // setAgentList([]);
                                      // setBranchList([]);
                                      // setCustomerList([]);
                                      // setTaxList([]);
                                      // setProductList([]);
                                      // setPaymentMethodList([]);
                                      validation.setFieldValue("company", e);
                                    }}
                                    options={companyList}
                                  ></Select>
                                  <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                    {" "}
                                    {companyLoading && (
                                      <Spinner color="primary" size="sm">
                                        Loading...
                                      </Spinner>
                                    )}
                                  </div>
                                </div>
                                {validation.touched.company && validation.errors.company && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.company}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <Select
                                  name="branch"
                                  placeholder="Pilih Proyek"
                                  value={validation.values.branch}
                                  onChange={(e) => {
                                    dispatch(setBranchSelect(e));
                                    validation.setFieldValue("branch", e);
                                    //handleGetProductVariant(companySelected.value, e.value);
                                  }}
                                  options={branchList}
                                ></Select>
                                {validation.touched.branch && validation.errors.branch && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.branch}
                                  </small>
                                )}
                              </div>
                              <div className={"mb-3 d-none"}>
                                <Input name="tenor" id="customername-field" className="form-control" placeholder="Input tenor" type="number" onFocus={(e) => e.target.select()} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tenor ?? ""} invalid={validation.touched.tenor && validation.errors.tenor ? true : false} />
                              </div>
                            </div>
                          </Col>
                          <Col lg={2}></Col>
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-3">
                                <Select
                                  name="agent"
                                  value={validation.values.agent}
                                  placeholder="Pilih Salesman"
                                  onChange={(e) => {
                                    validation.setFieldValue("agent", e);
                                    validationCustomer.setFieldValue("agent", e);
                                  }}
                                  options={agentList}
                                ></Select>
                                {validation.touched.agent && validation.errors.agent && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.agent}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <Select
                                  name="sales_type"
                                  placeholder="Pilih Jenis"
                                  value={validation.values.sales_type}
                                  onChange={(e) => {
                                    validation.setFieldValue("sales_type", e);
                                  }}
                                  options={salesTypeList}
                                ></Select>
                                {validation.touched.sales_type && validation.errors.sales_type && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.sales_type}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 col-lg-8">
                                <Select
                                  name="customer"
                                  value={validation.values.customer}
                                  placeholder="Pilih Konsumen"
                                  onChange={(e) => {
                                    validation.setFieldValue("customer", e);
                                  }}
                                  options={customerList}
                                ></Select>
                                {validation.touched.customer && validation.errors.customer && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.customer}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3 col-lg-4">
                                <Button
                                  color="light"
                                  value={validation.values.customer}
                                  className="btn-md w-100 btn-soft-success"
                                  onClick={() => {
                                    toggleCustomer();
                                  }}
                                >
                                  <i className="ri-add-fill me-1 align-bottom"></i> Tambah
                                </Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className={"pt-0 pb-4 ps-4 pe-4"}>
                        <div className="pt-4">
                          <h4 className="mb-3">
                            Transaksi Pembayaran <span className="text-success"> {validation?.values?.customer?.label} </span>
                          </h4>
                          <div className="row mb-3">
                            <div className="col-lg-5">
                              <div className="hstack gap-2">
                                <div className="mb-3" style={{ width: "65%" }}>
                                  <Select
                                    name="paymentMethod"
                                    value={validation.values.paymentMethod}
                                    placeholder="Pilih Jenis Transaksi"
                                    onChange={(e) => {
                                      validation.setFieldValue("paymentMethod", e);
                                    }}
                                    options={paymentMethodList}
                                  ></Select>
                                  {validation.touched.paymentMethod && validation.errors.paymentMethod && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.paymentMethod}
                                    </small>
                                  )}
                                </div>
                                <div className="ms-2 mb-3" style={{ width: "35%" }}>
                                  <Flatpickr
                                    className="form-control"
                                    id="datepicker-publish-input"
                                    placeholder="Tanggal"
                                    options={{
                                      mode: "single",
                                      dateFormat: "Y/m/d",
                                    }}
                                    onChange={(selectedDates, dateStr) => {
                                      validation.setFieldValue("cashat", dateStr);
                                    }}
                                    value={validation.values.cashat ?? ""}
                                  />
                                </div>
                              </div>
                              <div>
                                <div className="mb-3">
                                  <Select
                                    name="budget"
                                    value={validation.values.budget}
                                    placeholder="Pilih Cashflow"
                                    onChange={(e) => {
                                      validation.setFieldValue("budget", e);
                                    }}
                                    options={budgetList}
                                  ></Select>
                                  {validation.touched.budget && validation.errors.budget && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.budget}
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="mb-3">
                                <Input type="textarea" className="form-control" id="description" placeholder="Keterangan (Jika Ada)" name="description" rows={2} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.description && validation.errors.description ? true : false} />
                              </div>
                            </div>
                            <div className="col-lg-2"></div>
                            <div className="col-lg-5">
                              <div className="mb-3">
                                <Select
                                  name="sales_promo"
                                  placeholder="Pilih Diskon Penjualan"
                                  value={validation.values.sales_promo}
                                  onChange={(e) => {
                                    validation.setFieldValue("sales_promo", e);
                                  }}
                                  options={salesPromoList}
                                ></Select>
                              </div>
                              <div className="mb-3">
                                <div className="input-group">
                                  <CurrencyInput id="cash_amount" name="cash_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control-lg fw-semibold" placeholder="Jumlah Pembayaran" defaultValue={validation.values.amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validation.setFieldValue("cash_amount", value)} />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="table-responsive mb-3 table-card">
                            {(info?.sales_trans || []).length > 0 && (
                              <Table className="invoice-table table-borderless table-nowrap mb-0">
                                <thead className="align-middle">
                                  <tr className="table-active">
                                    <th scope="col"></th>
                                    <th scope="col" style={{ width: "20px" }}>
                                      #
                                    </th>
                                    <th scope="col">No Transaksi</th>
                                    <th scope="col">Tanggal Transaksi</th>
                                    <th scope="col" className="text-center" style={{ width: "170px" }}>
                                      Jumlah
                                    </th>
                                    <th scope="col">Keterangan</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(info?.sales_trans || []).filter((f) => f.statusId === 1 || f.statusId === 2 || f.statusId === 3).sort((a, b) => a.transaction_no - b.transaction_no).map((o, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-success"
                                            onClick={() => {
                                              setDetailType("receipt");
                                              setReceiptAmount(o.amount);
                                              setReceiptDate(o.transactionat);
                                              setReceiptCode(o.transaction_no);
                                              setReceiptNote(o.description + itemName + ", " + branchCode);
                                              setModalDetail(false);
                                              toggleReceipt();
                                            }}
                                          >
                                            KUITANSI
                                          </button>
                                        </td>
                                        <td className="product-id">{i + 1}</td>
                                        <td className="fw-semibold">{o.transaction_no}</td>
                                        <td className="fw-semibold">{handleValidDate(o.transactionat, "D MMM YYYY")}</td>
                                        <td className="fw-semibold text-center" style={{ width: "170px" }}>
                                          {currencyFormat(o.amount)}
                                        </td>
                                        <td className="fw-semibold">{o.description}</td>
                                      </tr>
                                    );
                                  })}
                                  {(info?.sales_trans || []).length === 0 && (
                                    <tr>
                                      <td colSpan="5" className="p-3 text-center fs-14">
                                        Belum ada transaksi
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggle();
                            validation.resetForm({});
                          }}
                        >
                          TUTUP
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {"SIMPAN TRANSAKSI"}
                            &nbsp;{" "}
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {"Detail Pemesanan"}
                  </ModalHeader>
                  <ModalBody>
                    {info && (
                      <CardBody className="pt-4 ps-4 pe-4">
                        <Row>
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-1 fs-14 fw-semibold">{info.sales_client && info.sales_client.name}</div>
                              <div className="mb-3 fs-14 fw-semibold">{info.sales_company && info.sales_company.name}</div>
                              <div className="mb-1 fs-14">{info.sales_branch && info.sales_branch.name}</div>
                              <div className="mb-3 fs-14">
                                PENJUALAN {info.sales_type && info.sales_type.name} {info.tenor ? ", Tenor " + info.tenor + " Bulan" : ""}
                              </div>
                            </div>
                          </Col>
                          <Col lg={3}></Col>
                          <Col lg={4} className="ms-auto">
                            <div className="mb-2 fs-14 fw-semibold">No Penjualan : {info.transaction_no && info.transaction_no}</div>
                            <div className="mb-2 fs-14 fw-semibold">Bank Pengajuan : {info.sls_bb && info.sls_bb.name}</div>
                            <div className="mb-2 fs-14 fw-semibold">
                              {info.sales_customer && info.sales_customer.name} <span className="badge text-uppercase badge-soft-info fs-12">{info.sales_agent && info.sales_agent.name}</span>
                            </div>
                          </Col>
                        </Row>
                        <div>
                          <h4 className="mb-3 mt-3 pt-3 border-top">History Pembayaran</h4>
                          <div className="pt-3 ps-3 pe-3">
                            <div className="table-responsive mb-3 table-card">
                              <Table className="invoice-table table-borderless table-nowrap mb-0">
                                <thead className="align-middle">
                                  <tr className="table-active">
                                    <td></td>
                                    <td style={{ width: "20px" }}>#</td>
                                    <td>No Transaksi</td>
                                    <td>Tanggal Transaksi</td>
                                    <td className="text-end" style={{ width: "120px" }}>
                                      Jumlah
                                    </td>
                                    <td>Keterangan</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(info?.sales_trans || []).filter((f) => f.statusId === 1 || f.statusId === 2 || f.statusId === 3).map((o, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-success"
                                            onClick={() => {
                                              setDetailType("receipt");
                                              setReceiptAmount(o.amount);
                                              setReceiptDate(o.transactionat);
                                              setReceiptCode(o.transaction_no);
                                              setReceiptNote(o.description + itemName + ", " + branchCode);
                                              setModalDetail(false);
                                              toggleReceipt();
                                            }}
                                          >
                                            KWITANSI
                                          </button>
                                        </td>
                                        <td className="product-id">{i + 1}</td>
                                        <td>{o.transaction_no}</td>
                                        <td>{handleValidDate(o.transactionat)}</td>
                                        <td className="text-end" style={{ width: "120px" }}>
                                          {currencyFormat(o.amount)}
                                        </td>
                                        <td>{o.description}</td>
                                      </tr>
                                    );
                                  })}
                                  {info?.sales_trans && info?.sales_trans.length === 0 && (
                                    <tr>
                                      <td colSpan="6" className="p-3 text-center fs-14">
                                        Belum ada transaksi Penerimaan
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                          {info.credit_amount && info.credit_amount > 0 && (
                            <div className="row border-top">
                              <div className="col-lg-5 mt-3">
                                <div className="mb-3">
                                  <label className="text-muted">Maksimum KPR : </label>
                                  <div className="fw-semibold fs-16">{currencyFormat(parseFloat(info.sub_amount) - (parseFloat(info.sub_amount ?? 0) * (1 / 100) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0)) || 0)}</div>
                                </div>
                                <div className="mb-3">
                                  <label className="text-muted">ACC KPR : </label>
                                  <div className={currencyFormat(info.credit_amount) ? "fw-semibold text-success fs-16" : "fw-semibold fs-16"}>{currencyFormat(info.credit_amount)}</div>
                                </div>
                                <div className="row">
                                  <div className="mb-1 col-lg-12">
                                    <label>Tanggal SP3K</label> {handleValidDate(info.bankat)} (Tenor {info.tenor})
                                  </div>
                                </div>
                                <div className="mb-1">
                                  <label>Status : </label> <span className="fw-semibold fs-14">{info.sales_bank_status && info.sales_bank_status.name}</span>
                                </div>
                                <div className="mb-3">
                                  <label>Keterangan Bank : </label> {info.description_bank ? info.description_bank : "-"}
                                </div>
                              </div>
                              <div className="col-lg-3"></div>
                              <div className="col-lg-4 mt-3">
                                <div className="mb-3">
                                  <label className="text-muted">Penurunan KPR : </label>
                                  <div className="fw-semibold fs-16 text-danger">{currencyFormat(parseFloat(info.sub_amount) - (parseFloat(info.sub_amount) * (1 / 100) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0)) - info.credit_amount || 0)}</div>
                                </div>
                                <div className="mb-3">
                                  <label className="text-muted">TOTAL Tagihan : </label>
                                  <div className="fw-semibold text-danger fs-16">{currencyFormat(info.total_amount)}</div>
                                </div>
                              </div>
                            </div>
                          )}

                          {info.completedat && (
                            <div className="pt-4 border-top">
                              <h4 className="mb-3">Jadwal Akad</h4>
                              <div className="row">
                                <div className="mb-3 col-lg-4">
                                  <label>Tanggal Akad : </label> <span className="fw-semibold text-success fs-16">{info.completedat && handleValidDate(info.completedat)}</span>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="pt-4 border-top">
                            <h4 className="mb-3">Bukti Transaksi</h4>
                            <div className="mb-3">
                              {info.sales_file &&
                                info.sales_file.length > 0 &&
                                info.sales_file.map((f, i) => {
                                  if (f.isDeleted) {
                                    return null;
                                  } else {
                                    return (
                                      <div key={i} className="border-bottom mb-3">
                                        <div className="d-flex justify-content-between mb-3 align-items-center">
                                          <div className="me-2">
                                            {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                              <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                            ) : (
                                              <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                              </Link>
                                            )}
                                          </div>

                                          <div className="text-truncate">{f.originalname}</div>
                                        </div>
                                      </div>
                                    );
                                  }
                                })}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    )}
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalDetail(false);
                        }}
                      >
                        TUTUP
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalReceipt" isOpen={modalReceipt} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleReceipt}>
                    KWITANSI PEMBAYARAN
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col lg={12}>
                        <div className="hero-kwitansi" style={{ padding: "20px 20px 20px 20px" }}>
                          {(companySelected?.value === 1 || companySelected?.value === 4) &&
                            <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                              <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                                <img src={logoHas} alt="" height="80" width="80" />
                              </div>
                              <div style={{ textAlign: "left" }}>
                                <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{companySelected?.label}</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                              </div>
                            </div>
                          }

                          {companySelected?.value === 2 &&
                            <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                              <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                                <img src={logoCms} alt="" height="80" width="80" />
                              </div>
                              <div style={{ textAlign: "left" }}>
                                <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{companySelected?.label}</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                              </div>
                            </div>
                          }

                          {companySelected?.value === 3 &&
                            <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
                              <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
                                <img src={logoWAP} alt="" height="80" width="80" />
                              </div>
                              <div style={{ textAlign: "left" }}>
                                <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{companySelected?.label}</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Jl Sudarmanik Desa Jagabaya Kec. Parung Panjang, Bogor</p>
                                <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
                              </div>
                            </div>
                          }

                          <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", paddingTop: "30px", paddingBottom: "30px", display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px", fontSize: "22px", fontWeight: "bold" }}>KWITANSI</div>
                          <div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px" }}>{`No : ${branchCode ?? ""}${receiptCode ?? "-"}`}</div>
                            <table style={{ marginTop: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <tbody>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Telah Diterima Dari</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{receiptName ?? "-"}</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Banyaknya Uang</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{`${receiptAmount !== null ? `${numberToWords(receiptAmount)}` : "-"}`}</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Untuk Pembayaran</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{receiptCode ? `Sales Invoice #${branchCode ?? ""}${receiptCode}` : "-"}</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Keterangan</td>
                                  <td style={{ width: "15px" }}>:</td>
                                  <td style={{ width: "100%" }}>{receiptNote}</td>
                                </tr>
                              </tbody>
                            </table>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                              <div style={{ flex: "1 1 0%", marginTop: "40px" }}>
                                <div style={{ display: "flex", fontSize: "18px", fontWeight: "bold" }}>
                                  <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", padding: "10px 20px" }}>Jumlah</div>
                                  <div style={{ borderTop: "1px solid #000000", borderBottom: "1px solid #000000", padding: "10px 20px", backgroundColor: "rgb(255, 170, 0)" }}>{`Rp. ${currencyFormat(receiptAmount ?? 0)}`}</div>
                                </div>
                              </div>
                              <div style={{ textAlign: "center" }}>
                                <p style={{ marginTop: "30px", padding: "0", lineHeight: "0" }}>Bogor, {handleValidDate(receiptDate, "D MMM YYYY")}</p>
                                {companySelected?.label}
                                <div style={{ textAlign: "center", padding: "10px 0px" }}>
                                  <QRCodeSVG value={`https://pkg.pkdeveloper.id/qr/sl${receiptCode}-${companySelected?.value}`} size={90} bgColor={"#ffffff"} fgColor={"#000000"} level={"L"} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleReceipt();
                        }}
                      >
                        TUTUP
                      </button>
                      <ButtonPrintReceipt innerRef={printRef} title={`KWITANSI-${receiptName ?? "-"}`} />
                    </div>
                  </div>
                </Modal>

                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
                    KONFIRMASI DATA
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApprove.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="text-center">
                        <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <p className="fs-16">{sales && sales.actionTitle}</p>
                        </div>
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Enter Notes If Any" rows={4} type="textarea" onChange={validationApprove.handleChange} onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalApprove(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModal" isOpen={modalCustomer} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleCustomer}>
                    {!!isEdit ? "Edit Konsumen" : "Tambah Konsumen"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationCustomer.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="agent-field" className="form-label">
                              Marketing
                              {agentLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="agent"
                              value={validationCustomer.values.agent}
                              placeholder="Pilih Salesman"
                              onChange={(e) => {
                                validationCustomer.setFieldValue("agent", e);
                              }}
                              options={agentList}
                            ></Select>
                            {validationCustomer.touched.agent && validationCustomer.errors.agent && <FormFeedback type="invalid">{validationCustomer.errors.agent}</FormFeedback>}
                          </div>

                          <div className="mb-3 d-none">
                            <Label htmlFor="customerGroup-field" className="form-label">
                              Customer Group (Optional)&nbsp;
                              {customerGroupsLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="customerGroup"
                              value={validationCustomer.values.customerGroup}
                              placeholder="Select Customer Group"
                              isDisabled={customerGroupList.length > 0 ? false : true}
                              onChange={(e) => {
                                validationCustomer.setFieldValue("customerGroup", e);
                              }}
                              options={customerGroupList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <label>Tanggal Kunjungan</label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tanggal"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationCustomer.setFieldValue("visitedat", dateStr);
                              }}
                              value={validationCustomer.values.visitedat ?? ""}
                            />
                            {validationCustomer.touched.visitedat && validationCustomer.errors.visitedat ? <p className="text-danger fs-11">{validationCustomer.errors.visitedat}</p> : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="customername-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="customername-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.name ?? ""} invalid={validationCustomer.touched.name && validationCustomer.errors.name ? true : false} />
                            {validationCustomer.touched.name && validationCustomer.errors.name ? <FormFeedback type="invalid">{validationCustomer.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="password-field" className="form-label">
                              Password <span className="text-danger">*</span>
                            </Label>
                            <Input name="password" id="password-field" className="form-control" placeholder="Isi Password" type="password" validate={{ required: { value: true } }} onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.password ?? ""} invalid={validationCustomer.touched.password && validationCustomer.errors.password ? true : false} />
                            {validationCustomer.touched.password && validationCustomer.errors.password ? (
                              <small className="text-danger" type="invalid">
                                {validationCustomer.errors.password}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="phone-field" className="form-label">
                              No Telepon
                            </Label>
                            <Input name="phone" id="phone-field" className="form-control" placeholder="Isi No. Telepon" type="text"
                              onChange={(e) => {
                                validationCustomer.setFieldValue("phone", e.target.value);
                                validationCustomer.setFieldValue("email", e.target.value + '@mail.com');
                              }}
                              onBlur={validationCustomer.handleBlur} value={validationCustomer.values.phone ?? ""} invalid={validationCustomer.touched.phone && validationCustomer.errors.phone ? true : false} />
                            {validationCustomer.touched.phone && validationCustomer.errors.phone ? <FormFeedback type="invalid">{validationCustomer.errors.phone}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="email-field" className="form-label">
                              Email
                            </Label>
                            <Input name="email" id="email-field" className="form-control" placeholder="Isi Email" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.email ?? ""} invalid={validationCustomer.touched.email && validationCustomer.errors.email ? true : false} />
                            {validationCustomer.touched.email && validationCustomer.errors.email && <FormFeedback type="invalid">{validationCustomer.errors.email}</FormFeedback>}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="pekerjaan-field" className="form-label">
                              Sumber Kunjungan
                            </Label>
                            <Select
                              name="source_type"
                              value={validationCustomer.values.source_type}
                              placeholder="Pilih Sumber Kunjungan"
                              onChange={(e) => {
                                validationCustomer.setFieldValue("source_type", e);
                              }}
                              options={sourceTypeData}
                            ></Select>
                          </div>

                          <div className="mb-3 d-none">
                            <Label htmlFor="des-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="address" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.address ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="street-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat" type="textarea" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.street} invalid={validationCustomer.touched.street && validationCustomer.errors.street ? true : false} />
                            {validationCustomer.touched.street && validationCustomer.errors.street && <FormFeedback type="invalid">{validationCustomer.errors.street}</FormFeedback>}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="zip-field" className="form-label">
                              Kode Pos
                            </Label>
                            <Input name="zip" id="zip-field" className="form-control" placeholder="Isi Kode Pos" type="number" validate={{ required: { value: true } }} onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.zip ?? ""} />
                          </div>
                        </div>
                        <div className="col-lg-6 mb-3">
                          <div className="row">
                            <div className="col-md-5 mb-3">
                              <Label htmlFor="identity_type" className="form-label">
                                Jenis ID{" "}
                                {identityTypeLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="identity_type"
                                value={validationCustomer.values.identity_type}
                                placeholder="Jenis ID"
                                onChange={(e) => {
                                  validationCustomer.setFieldValue("identity_type", e);
                                }}
                                options={identityTypeList}
                              ></Select>
                              {validationCustomer.touched.identity_type && validationCustomer.errors.identity_type ? (
                                <small className="text-danger" type="invalid">
                                  {validationCustomer.errors.identity_type}
                                </small>
                              ) : null}
                            </div>
                            <div className="col-md-7 mb-3">
                              <Label htmlFor="identity_type" className="form-label">
                                Nomor Identitas
                              </Label>
                              <Input name="identity" id="identity-field" className="form-control" placeholder="Isi No. Identitas" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.identity ?? ""} invalid={validationCustomer.touched.identity && validationCustomer.errors.identity ? true : false} />
                              {validationCustomer.touched.identity && validationCustomer.errors.identity ? <FormFeedback type="invalid">{validationCustomer.errors.identity}</FormFeedback> : null}
                            </div>
                          </div>
                          <div className=" mb-3">
                            <Label htmlFor="bank-field" className="form-label">
                              Bank
                            </Label>
                            <Select
                              name="bank"
                              value={validationCustomer.values.bank}
                              placeholder="Pilih Bank"
                              onChange={(e) => {
                                validationCustomer.setFieldValue("bank", e);
                              }}
                              options={bankList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="number-field" className="form-label">
                              No. Rekening
                            </Label>
                            <Input name="number" id="number-field" className="form-control" placeholder="Isi No. Rekening" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.number ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="tax_number-field" className="form-label">
                              NPWP
                            </Label>
                            <Input name="tax_number" id="tax_number-field" className="form-control" placeholder="Input No. Pajak" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.tax_number ?? ""} />
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="insurance_number-field" className="form-label">
                              No. BPJS
                            </Label>
                            <Input name="insurance_number" id="insurance_number-field" className="form-control" placeholder="Isi No. Pajak" type="text" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.insurance_number ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description_visit-field" className="form-label">
                              Tujuan Kunjungan
                            </Label>
                            <Input name="description_visit" id="description_visit-field" className="form-control" placeholder="Input Keterangan" type="textarea" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.description_visit} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description_result-field" className="form-label">
                              Hasil Kunjungan
                            </Label>
                            <Input name="description_result" id="description_result-field" className="form-control" placeholder="Input Keterangan" type="textarea" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.description_result} />
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="description-field" className="form-label">
                              Customer Description (optional)
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Input Keterangan" type="textarea" onChange={validationCustomer.handleChange} onBlur={validationCustomer.handleBlur} value={validationCustomer.values.description} />
                          </div>
                          <div className="mb-3 position-relative d-none">
                            <Label htmlFor="customer_contact" className="form-label">
                              Kontak Darurat
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                handleCustomerContactAdd();
                              }}
                            >
                              <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Add
                            </button>
                          </div>
                          {customerContactItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3 d-flex gap-3 align-items-center">
                                <div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Nama Kontak
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.name`}
                                        className="form-control"
                                        placeholder="Isi Nama Kontak"
                                        type="text"
                                        value={customerContactItem[i].name ?? ""}
                                        onChange={(e) => {
                                          validationCustomer.setFieldValue(`customerContactItem.${i}.name`, e.target.value);
                                          customerContactItem[i].name = e.target.value;
                                        }}
                                        onBlur={validationCustomer.handleBlur}
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        No. Telp Kontak
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.phone`}
                                        className="form-control"
                                        placeholder="Isi Telepon"
                                        type="text"
                                        value={customerContactItem[i].phone ?? ""}
                                        onChange={(e) => {
                                          validationCustomer.setFieldValue(`customerContactItem.${i}.phone`, e.target.value);
                                          customerContactItem[i].phone = e.target.value;
                                        }}
                                        onBlur={validationCustomer.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Email
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.email`}
                                        className="form-control"
                                        placeholder="Isi Email"
                                        type="text"
                                        value={customerContactItem[i].email ?? ""}
                                        onChange={(e) => {
                                          validationCustomer.setFieldValue(`customerContactItem.${i}.email`, e.target.value);
                                          customerContactItem[i].email = e.target.value;
                                        }}
                                        onBlur={validationCustomer.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Hubungan Dengan Konsumen
                                      </Label>
                                      <Input
                                        name={`customerContactItem.${i}.position`}
                                        className="form-control"
                                        placeholder="Isi Hubungan Dengan Konsumen"
                                        type="text"
                                        value={customerContactItem[i].position ?? ""}
                                        onChange={(e) => {
                                          validationCustomer.setFieldValue(`customerContactItem.${i}.position`, e.target.value);
                                          customerContactItem[i].position = e.target.value;
                                        }}
                                        onBlur={validationCustomer.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <Button
                                  className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                                  style={{ width: "70px" }}
                                  onClick={() => {
                                    setCustomerContactItem((val) => [...val.slice(0, i), ...val.slice(i + 1)]);
                                  }}
                                >
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Button>
                              </div>
                            );
                          })}
                          <div className="mb-3 position-relative d-none">
                            <Label htmlFor="customer_contact" className="form-label">
                              Dokumen Konsumen
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                toggleMediaCustomer();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {salesImgCustomer.map((f, i) => {
                            if (f.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                        <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                      ) : (
                                        <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                          <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                        </Link>
                                      )}
                                    </div>
                                    <div className="text-truncate">{f.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          handleDeleteFileCustomer(f);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={toggleCustomer}>
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update Data Konsumen" : "Simpan Data Konsumen"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
                <ModalInputFile onSelect={handleSelectFileCustomer} loading={loading} modal={modalMediaCustomer} toggle={toggleMediaCustomer} />
                <ModalInputFile onSelect={handleSelectFileApplicationDoc} loading={loading} modal={modalMediaApplicationDoc} toggle={toggleMediaApplicationDoc} />

                <div className="d-none">
                  {(info?.sales_trans || []).map((o, i) => {
                    return (
                      <p id={"sl" + o.transaction_no} key={i}>
                        <QRCodeSVG value={`https://pkg.pkdeveloper.id/qr/sl${o.transaction_no}-${companySelected?.value}`} size={90} bgColor={"#ffffff"} fgColor={"#000000"} level={"L"} />
                      </p>
                    );
                  })}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {detailType === "receipt" && <PrintDocReceipt innerRef={printRef} code={receiptCode} amount={receiptAmount} date={receiptDate} note={receiptNote} name={receiptName} branchCode={branchCode} companyName={companySelected?.label} companyValue={companySelected?.value} />}
    </div>
  );
};
Sales.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Sales));
